import Vue from 'vue';
import Vuex from 'vuex';

import tiers from './modules/tiers';
import commandes from './modules/commandes';
import cart from './modules/cart';
import referentiel from './modules/referentiel';
import exploitation from './modules/exploitation';
import contrats from './modules/contrats';
import navigation from './modules/navigation';
import user from './modules/user';
import reglement from './modules/reglement';
import articles from './modules/articles';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    tiers,
    commandes,
    cart,
    referentiel,
    exploitation,
    reglement,
    contrats,
    navigation,
    user,
    articles
  },
  actions: {
    reset () {
      window.sessionStorage.clear();
      for (let key in this._modules.root._children) {
        const module = this._modules.root._children[key];
        if (module._rawModule.actions.reset) {
          this.dispatch(key + '/reset');
        } else {
          // eslint-disable-next-line no-console
          console.warn('no reset action for module ' + key);
        }
      }
    }
  },
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production'
});

export default store;
